import Badge from "@/components/Badge";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

type ExternalBadgeProps = Omit<
  ComponentProps<typeof Badge>,
  "color" | "variant"
>;

const ExternalBadge = (props: ExternalBadgeProps) => {
  const { t } = useTranslation();

  const { children, ...restProps } = props;

  return (
    <Badge {...restProps} color="high-contrast" variant="filled">
      {children ?? t("devices.external")}
    </Badge>
  );
};
export default ExternalBadge;
